import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ServiceCategoryBrowse from './pages/service-category-browse';
import DigitalServiceStandee from './pages/digital-service-standee';
import ServiceCatalogHome from './pages/service-catalog-home';
import AdminControlPanel from './pages/admin-control-panel';
import AboutEbasVenture from './pages/about-ebas-venture';
import AdminSecureLoginPortal from './pages/admin-secure-login-portal';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import { AuthProvider } from './contexts/AuthContext';

const RoutesContent = () => {
  useGoogleAnalytics();
  
  return (
    <RouterRoutes>
      <Route path="/" element={<ServiceCatalogHome />} />
      <Route path="/service-catalog-home" element={<ServiceCatalogHome />} />
      <Route path="/service-category-browse" element={<ServiceCategoryBrowse />} />
      <Route path="/digital-service-standee" element={<DigitalServiceStandee />} />
      <Route path="/about-ebas-venture" element={<AboutEbasVenture />} />
      <Route path="/admin-secure-login-portal" element={<AdminSecureLoginPortal />} />
      <Route path="/admin-control-panel" element={<AdminControlPanel />} />
      <Route path="/admin-control-panel/*" element={<AdminControlPanel />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RoutesContent />
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
